import { getStaticAsset } from '@/utils/staticAsset';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { FairnessBanner, SectionParagraph } from '../styles';

const Banner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FairnessBanner>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          background: (theme) => theme.palette.bg.main,
          width: '326px',
        }}
      >
        <img
          src={getStaticAsset(
            '/assets/images/casino/crash-info/rush-fairness.png',
          )}
          alt={'Rush Game'}
        />
      </Box>
      <Box sx={{ ml: 3, maxWidth: '558px' }}>
        <Typography sx={{ fontSize: '24px' }}>{t('PROVABLY FAIR')}</Typography>
        <Typography
          sx={{ mt: 2, mb: 2, color: '#fff', fontSize: '16px' }}
          variant={'body1'}
        >
          {t('What does it mean?')}
        </Typography>
        <SectionParagraph>
          {t(
            ' All game results for the next 6 million rounds have been predetermined. Before each\n' +
              '              round, we reveal a hash of the result, making it impossible for us to change the result\n' +
              '              after the fact.',
          )}
        </SectionParagraph>
        <SectionParagraph>
          {t(
            'We have actually chained all results, making it impossible for us to even change future\n' +
              '              results. And before generating the chain of results, we revealed the first hash,\n' +
              '              published this to , and mixed in a future Bitcoin blockhash we could not have known.\n' +
              '              This makes all results provably fair.',
          )}
        </SectionParagraph>
      </Box>
    </FairnessBanner>
  );
};

export default Banner;
